export default __webpack_public_path__ + "static/media/icon-scanning.6d96a1eb.gif";